<ul nz-menu [nzMode]="screenSize === 'large' || screenSize === 'x-large' ? 'horizontal' : 'inline'">
  <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menus }"></ng-container>
  <ng-template #menuTpl let-menus>
    <ng-container *ngFor="let menu of menus">
      <li *ngIf="menu.ChildMenus.length === 0" nz-menu-item nzMatchRouter (click)="menuClicked()" [ngClass]="{
        'pull-right': menu.Icon === 'setting' || menu.Icon === 'fal fa-cog'
        }">
        <ng-container *ngIf="menu.Icon !== '' && menu.Icon !== null">
          <i nz-icon [nzType]="menu.Icon" [class]="'menu-' + menu.Icon" nzTheme="outline"
            *ngIf="menu.Icon != null && menu.Icon.indexOf('fa-') === -1"></i>
          <i *ngIf="menu.Icon.indexOf('fa-') !== -1" [class]="'menu-icon ' + menu.Icon"></i>
        </ng-container>
        <a *ngIf="
          menu.Target == null ||
          (menu.Target !== '_blank' &&
            menu.Target !== '_blank_auth')
        " [routerLink]="getMenuUrl(menu)">{{ menu.Label | locale }}</a>
        <a *ngIf="menu.Target === '_blank'" [href]="menu.Url" target="_blank">{{
          menu.Label | locale
          }}</a>
        <a *ngIf="menu.Target === '_blank_auth'" [href]="urlPrefix + menu.Url + '&' + urlSuffix" target="_blank_auth">{{
          menu.Label | locale }}</a>
      </li>
      <ng-container *ngIf="menu.Target === '#divider'">
        <nz-divider></nz-divider>
      </ng-container>
      <li *ngIf="menu.ChildMenus.length > 0 && menu.ParentMenu != app.parentMenuId" nz-menu-group [ngClass]="{
        'pull-rightx': menu.Icon === 'setting' || menu.Icon === 'fal fa-cog'
      }">
        <span title>
          <ng-container *ngIf="menu.Icon !== '' && menu.Icon !== null">
            <i nz-icon [nzType]="menu.Icon"  [class]="'menu-' + menu.Icon" nzTheme="outline"
              *ngIf="menu.Icon != null && menu.Icon.indexOf('fa-') === -1"></i>
            <i *ngIf="menu.Icon != null && menu.Icon.indexOf('fa-') !== -1" [class]="'menu-icon ' + menu.Icon"></i>
          </ng-container>
          <span>{{ menu.Label | locale }} </span>
        </span>
        <ul>
          <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menu.ChildMenus }"></ng-container>
        </ul>
      </li>
      <li *ngIf="menu.ChildMenus.length > 0 && menu.ParentMenu == app.parentMenuId" nz-submenu [ngClass]="{
          'pull-rightx': menu.Icon === 'setting' || menu.Icon === 'fal fa-cog'
        }">
        <span title>
          <ng-container *ngIf="menu.Icon !== '' && menu.Icon !== null">
            <i nz-icon [nzType]="menu.Icon" [class]="'menu-' + menu.Icon" nzTheme="outline"
              *ngIf="menu.Icon != null && menu.Icon.indexOf('fa-') === -1"></i>
            <i *ngIf="menu.Icon != null && menu.Icon.indexOf('fa-') !== -1" [class]="'menu-icon ' + menu.Icon"></i>
          </ng-container>
          <span>{{ menu.Label | locale }} </span>
        </span>
        <ul>
          <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menu.ChildMenus }"></ng-container>
        </ul>
      </li>
    </ng-container>
  </ng-template>
</ul>

<!-- <ul
  nz-menu
  [nzMode]="
    screenSize === 'large' || screenSize === 'x-large' ? 'horizontal' : 'inline'
  "
>
  <ng-container *ngFor="let menu of menus">
    <li
      nz-menu-item
      nzMatchRouter
      *ngIf="menu.ChildMenus.length === 0"
      (click)="menuClicked()"
      [ngClass]="{
        'pull-right': menu.Icon === 'setting' || menu.Icon === 'fal fa-cog'
      }"
    >
      <ng-container *ngIf="menu.Icon !== '' && menu.Icon !== null">
        <i
          nz-icon
          [nzType]="menu.Icon"
          nzTheme="outline"
          *ngIf="menu.Icon != null && menu.Icon.indexOf('fa-') === -1"
        ></i>
        <i
          *ngIf="menu.Icon.indexOf('fa-') !== -1"
          [class]="'menu-icon ' + menu.Icon"
        ></i>
      </ng-container>
      <a
        *ngIf="
          menu.Target == null ||
          (menu.Target !== '_blank' &&
            menu.Target !== '_blank_auth' &&
            menu.Target !== '#divider')
        "
        [routerLink]="getMenuUrl(menu)"
        >{{ menu.Label | locale }}</a
      >
      <a *ngIf="menu.Target === '_blank'" [href]="menu.Url" target="_blank">{{
        menu.Label | locale
      }}</a>
      <a
        *ngIf="menu.Target === '_blank_auth'"
        [href]="urlPrefix + menu.Url + '&' + urlSuffix"
        target="_blank_auth"
        >{{ menu.Label | locale }}</a
      >
    </li>
    <ng-container *ngIf="menu.Target === '#divider'">
      <nz-divider></nz-divider>
    </ng-container>
    <li
      nz-submenu
      *ngIf="menu.ChildMenus.length > 0"
      [ngClass]="{
        'pull-rightx': menu.Icon === 'setting' || menu.Icon === 'fal fa-cog'
      }"
    >
      <span title>
        <ng-container *ngIf="menu.Icon !== '' && menu.Icon !== null">
          <i
            nz-icon
            [nzType]="menu.Icon"
            nzTheme="outline"
            *ngIf="menu.Icon != null && menu.Icon.indexOf('fa-') === -1"
          ></i>
          <i
            *ngIf="menu.Icon != null && menu.Icon.indexOf('fa-') !== -1"
            [class]="'menu-icon ' + menu.Icon"
          ></i>
        </ng-container>
        <span>{{ menu.Label | locale }} </span>
      </span>
      <ul>
        <ng-container *ngFor="let subMenu of menu.ChildMenus">
          <li nz-menu-item nzMatchRouter (click)="menuClicked()">
            <ng-container *ngIf="subMenu.Icon !== '' && subMenu.Icon !== null">
              <i
                nz-icon
                [nzType]="subMenu.Icon"
                nzTheme="outline"
                *ngIf="
                  subMenu.Icon != null && subMenu.Icon.indexOf('fa-') === -1
                "
              ></i>
              <i
                *ngIf="
                  subMenu.Icon != null && subMenu.Icon.indexOf('fa-') !== -1
                "
                [class]="'menu-icon ' + subMenu.Icon"
              ></i>
            </ng-container>
            <ng-container *ngIf="subMenu.Url !== null">
              <a
                *ngIf="subMenu.Target == null || subMenu.Target !== '_blank'"
                [routerLink]="getMenuUrl(subMenu)"
                >{{ subMenu.Label | locale }}</a
              >
              <a
                *ngIf="!(subMenu.Target == null || subMenu.Target !== '_blank')"
                [href]="subMenu.Url"
                target="_blank"
                >{{ subMenu.Label | locale }}</a
              >
              <a
                *ngIf="
                  !(
                    subMenu.Target == null ||
                    subMenu.Target !== '_blank_auth' ||
                    menu.Target === '#divider'
                  )
                "
                [href]="urlPrefix + subMenu.Url + '&' + urlSuffix"
                target="_blank_auth"
                >{{ subMenu.Label | locale }}</a
              >
            </ng-container>
            <span *ngIf="subMenu.Url === null">{{
              subMenu.Label | locale
            }}</span>
          </li>
          <ng-container *ngIf="subMenu.Target === '#divider'">
            <li
              nz-menu-divider
              style="
                background-color: rgba(0, 0, 0, 0.2);
                width: 90%;
                margin: auto;
              "
            ></li>
          </ng-container>
        </ng-container>
      </ul>
    </li>
  </ng-container>
</ul> -->
